import axios from 'axios'
// axios文档：https://www.kancloud.cn/yunye/axios/234845/
import router from '../router'
//域名，在这里设置您的域名
const baseURL  = 'https://hkdog.top/';
//配置
// 添加响应拦截器
axios.interceptors.response.use(function (response) {
	// 对响应数据做点什么
	if (response.status!==200) {
		alert('状态：'+response.status+'说明：'+response.statusText)
		return false
	}
	else if(response.data.code==4005){
		router.push({name:'login'})
		return false
	}
	return response.data
}, function (error) {
	// 对响应错误做点什么
	return Promise.reject(error);
});
var LANG = {
	zh:{
		text:'中文简体',
		value:'zh',
		apiValue:'zh-cn',
		changeValue:'zh-cn'
	},
	en:{
		text:'英文',
		value:'en',
		apiValue:'en-us',
		changeValue:'en-us'
	}
};
var DB = 'zWap';
if (!localStorage.hasOwnProperty(DB)) {
	localStorage[DB] = JSON.stringify({
		url:baseURL,
		token:'',
		uid:'',
		account:[]
	})
}
if (!JSON.parse(localStorage[DB]).hasOwnProperty('url')) {
	let  obj = JSON.parse(localStorage[DB]);
	obj.url = baseURL
	localStorage[DB] = JSON.stringify(obj)
}
var 
klineStyle = function (type) {
	// type:1数字货币；2期货
	var red = "#F9293E",
	redDown = "red-down",
	redUp = "red-up",
	lv = "#00aa3b",
	lvDown = "lv-down",
	lvUp = "lv-up";
	// 数字货币：绿色是涨，红色是跌
	if (type==1) {
		return {
			up:{
				color:lv,
				icon:lvUp
			},
			down:{
				color:red,
				icon:redDown
			},
		}
	}
	// 期货：红色是涨，绿色是跌
	else if (type==2) {
		return {
			up:{
				color:red,
				icon:redUp
			},
			down:{
				color:lv,
				icon:lvDown
			},
		}
	}

},
jump = function (path,second_after){
	second_after = typeof second_after !== 'undefined' ?  second_after : 1500;
	setTimeout(function () {
		router.push({path: path});
	},second_after)
},
setClientId = function (data) {
	return sessionStorage.setItem("client_id",data);
},
getClientId = function () {
	return sessionStorage.getItem("client_id");
},
setAccount = function (data){
	let obj = JSON.parse(localStorage[DB])
	obj.account = data
	return localStorage[DB] = JSON.stringify(obj)
},
getAccount = function (){
	let obj = JSON.parse(localStorage[DB])
	if (!obj.hasOwnProperty('account')) { 
		setAccount([])
	}
	return JSON.parse(localStorage[DB]).account
},
setLang = function (data){
	let obj = JSON.parse(localStorage[DB])
	obj.lang = data
	return localStorage[DB] = JSON.stringify(obj)
},
getLang = function (){
	let db = JSON.parse(localStorage[DB])
	if (!db || (db && !db.hasOwnProperty('lang'))) { 
		// 默认英文
		setLang('en')
		var lang = 'en';
		// 浏览器语言
		// var language =(navigator.language || navigator.browserLanguage).toLowerCase();
		// // zh-tw 中文繁体  zh-cn中文简体  en-us英语(美国)
		// if(language.indexOf('zh-cn')>=0)
		// {
		// 	// 假如浏览器语言是中文
		// 	setLang('zh')
		// 	var lang = 'zh';
		// }
		// else
		// {
		// 	// 假如浏览器语言是英文
		// 	setLang('en')
		// 	var lang = 'en';
		// }

	}
	else {
		var lang = db.lang
	}
	return lang
},
getLangList = function () {
	return LANG;
},
setToken = function (token){
	let obj = JSON.parse(localStorage[DB])
	obj.token = token
	return localStorage[DB] = JSON.stringify(obj)
},
getToken = function (){
	return JSON.parse(localStorage[DB]).token
},
removeToken = function (){
	let obj = JSON.parse(localStorage[DB])
	obj.token = ''
	return localStorage[DB] = JSON.stringify(obj)
},
setUid = function (uid){
	let obj = JSON.parse(localStorage[DB])
	obj.uid = uid
	return localStorage[DB] = JSON.stringify(obj)
},
getUid = function (){
	return JSON.parse(localStorage[DB]).uid
},
removeUid = function (){
	let obj = JSON.parse(localStorage[DB])
	obj.uid = 0
	return localStorage[DB] = JSON.stringify(obj)
},
config = {
	method: 'get',
	baseURL: baseURL,
	params: {
		token: getToken()
	},
	timeout: 10000,
},
post = function (api,params) {
	//+"?lang="+LANG[getLang()]['apiValue']
	config.url = api
	config.method = 'post'
	params.token = getToken()
	params.lang = LANG[getLang()]['apiValue']
	config.params = params
	// application/x-www-form-urlencoded
	// multipart/form-data
	// application/json
	// text/plain
	return axios(config)
},
get = function (api,params) {
	config.url = api
	config.method = 'get'
	params.token = getToken()
	params.lang = LANG[getLang()]['apiValue']
	config.params = params
	return axios(config)
},
upload = function (api,data) {
	config.url = api+"?lang="+LANG[getLang()]['apiValue']
	config.method = 'post'
	config.data = data
	config.headers = {
	  'Content-Type': 'multipart/form-data'
	}
	return axios(config)
},
/**
 * 隐藏字符串
 * @param  {[type]} str      字符串
 * @param  {[type]} frontLen 前面几位显示
 * @param  {[type]} endLen   后面几位显示
 * @return {[type]}          [description]
 */
hideStr = function (str,frontLen,endLen) { 
	var len = str.length-frontLen-endLen;
	var xing = '';
	for (var i=0;i<len;i++) {
		xing+='*';
	}
	return str.substring(0,frontLen)+xing+str.substring(str.length-endLen);
},
zmath = {
	//加
	add:function(a,b){
		let c, d, e;
	    try {
	        c = a.toString().split(".")[1].length;
	    } catch (f) {
	        c = 0;
	    }
	    try {
	        d = b.toString().split(".")[1].length;
	    } catch (f) {
	        d = 0;
	    }
	    return e = Math.pow(10, Math.max(c, d)), (this.mul(a, e) + this.mul(b, e)) / e;
	},
	//减
	sub:function (a,b) {
		let c, d, e;
	    try {
	        c = a.toString().split(".")[1].length;
	    } catch (f) {
	        c = 0;
	    }
	    try {
	        d = b.toString().split(".")[1].length;
	    } catch (f) {
	        d = 0;
	    }
	    return e = Math.pow(10, Math.max(c, d)), (this.mul(a, e) - this.mul(b, e)) / e;
	},
	//乘
	mul:function (a,b) {
		let c = 0,
	        d = a.toString(),
	        e = b.toString();
	    try {
	        c += d.split(".")[1].length;
	    } catch (f) {}
	    try {
	        c += e.split(".")[1].length;
	    } catch (f) {}
	    return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
	},
	//除
	div:function (a,b) {
		let c, d, e = 0,
	        f = 0;
	    try {
	        e = a.toString().split(".")[1].length;
	    } catch (g) {}
	    try {
	        f = b.toString().split(".")[1].length;
	    } catch (g) {}
	    return c = Number(a.toString().replace(".", "")), d = Number(b.toString().replace(".", "")), this.mul(c / d, Math.pow(10, f - e));
	},
};
export{ 
	setClientId,
	getClientId,
	klineStyle,
	getLangList,
	setLang, 
	getLang, 
	setAccount, 
	getAccount, 
	setToken, 
	getToken, 
	removeToken, 
	setUid, 
	getUid, 
	removeUid, 
	jump, 
	baseURL, 
	post, 
	get, 
	upload, 
	hideStr,
	zmath
};


// WEBPACK FOOTER //
// ./src/plugins/utils.js